<template>
  <div :class="['kendo-grid', theme, size]"></div>
</template>

<script>
  import eventHub from '@/shared/EventHub.js'

  export default {
    name: 'kendo-grid',
    props: {
      autoFitColumn: {
        type: Boolean,
        default () {
          return false
        }
      },
      theme: {
        type: String,
        default: function () {
          return 'k-grid-default'
        }
      },
      size: {
        type: String,
        default: function () {
          return 'k-grid-lg'
        }
      },
      columns: {
        type: Array
      },
      pageSize: {
        type: Number,
        default: 40
      },
      dataUrl: {
        type: String,
        default: function () {
          return ''
        }
      },
      filterUrl: {
        type: String,
        default () {
          return ''
        }
      },
      auth: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      value: {
        type: Array,
        default: function () {
          return []
        }
      },
      options: {
        type: Object,
        default: function () {
          return {}
        }
      },
      dataOptions: {
        type: Object,
        default: function () {
          return {}
        }
      },
      dblClickRow: {
        type: Function,
        default: function (id, item) {
          console.log('dblClickRow', id)
        }
      },
      addRow: {
        type: Function,
        default: function (id) {
          console.log('addRow', id)
        }
      },
      filename: {
        type: String,
        default: 'GridList.xlsx'
      },
      message: {
        type: String,
        default: '등록된 데이터가 없습니다.'
      }
    },
    watch: {
      value (val) {
        this.defaultOptions['dataSource']['data'] = val
        this.grid.dataSource.data(val)
      },
      dataUrl(url) {
        const grid = $(this.$el).data('kendoGrid')
        grid.dataSource.options.transport.read.url = url
        grid.dataSource.read()
      }
    },
    data () {
      return {
        title: '',
        defaultOptions: {
          height: '100%',
          resizable: true,
          reorderable: true,
          filterable: true,
          sortable: true,
          scrollable: true,
          pageable: {
            input: false,
            info: false,
            pageSizes: false,
            previousNext: true,
            numeric: true
          },
          selectable: 'row',
          allowCopy: true,
          columns: this.columns,
          excel: {
            allPages: true,
            fileName: this.filename,
            filterable: true
          },
          noRecords: true,
          messages: {
            noRecords: this.message
          }
        },
        grid: null,
        proxyData: []
      }
    },
    computed: {
      fields: function () {
        return _.keyBy(this.columns, 'field')
      }
    },
    methods: {
      setAutoFitColumn () {
        // 데이터 크기에 따른 컬럼 크기 설정
        const grid = $(this.$el).data('kendoGrid')
        for (const field in this.fields) {
          grid.autoFitColumn(field)
        }
      },
      refresh () {
        this.grid.dataSource.read()
      },
      onChange: function () {
        this.$emit('input', this.proxyData)
      },
      resizeGrid: _.debounce(function () {
        this.grid.resize()
      }, 300),
      insert: function (values, index) {
        index = index || 0
        return this.grid.dataSource.insert(values, index)
      },
      setDataSource () {
        const vm = this
        const dataSource = {
          filter: this.setDefaultFilter(),
          schema: {
            total: 'count',
            model: {
              fields: this.fields
            }
          },
          change: function (e) {
            // item이 변경되는 경우에 부분합을 변경한다.
            if (e.field && e.action === 'itemchange') {
              var _grid = $(this.$el).data('kendoGrid')
              _grid.footer.find('.k-footer-template').replaceWith(_grid.footerTemplate(this.aggregates()))
              vm.data = vm.getData()
            } else if (e.action === 'add') {
              vm.data = vm.getData()
            }
          },
          pageSize: this.pageSize,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        }

        return dataSource
      },
      setDefaultFilter () {
        let filter = {}
        const query = this.$route.query

        if (query.hasOwnProperty('tag')) {
          filter = { field: 'tag', operator: 'contains', value: query.tag }
        }
        else if (this.options.filters) {
          filter = this.options.filters
        }

        return filter
      },
      setTooltip () {
        $(this.$el).kendoTooltip({
          filter: 'td.show-tooltip',
          content: function (e) {
            return e.target.html()
          },
          position: 'top'
        })
      },
      setTouchEvent () {
        /**
         * jquery에 dblclick 이벤트는 모바일을 지원하지 않는다.
         * 따라서 클릭 이벤트를 이용해 같은 Element가 0.8초 이내에 두번 클릭이 일어났을 경우 더블클릭으로 인식하게끔 처리
         * 첫번째 클릭 이벤트가 발생한 시점과 두번째 클릭이벤트가 발생한 시점을 비교하여 처리한다.
         */
        const el = $(this.$el)
        let touchtime = 0

        el.off().on('click', 'tbody > tr > td', () => {
          if (touchtime === 0) {
            touchtime = new Date().getTime()
          } else {
            const nowtime = new Date().getTime()
            if((nowtime - touchtime) < 800) {
              touchtime = 0
              // 현재 선택된 행에 정보와 이벤트를 발생시킨다.
              var _grid = el.data('kendoGrid')
              var item = _grid.dataItem(_grid.tbody.find('.k-state-selected'))
              if (item) {
                this.dblClickRow(item.id, item)
              }
            } else {
              touchtime = new Date().getTime()
            }
          }
        })
      },
      select: function (uid) {
        this.grid.select($(this.$el).find('tr[data-uid="' + uid + '"]'))
      },
      getData: function () {
        return this.grid.dataSource.data()
      },
      download: function (filename = 'list.xlsx') {
        this.grid.saveAsExcel()
      }
    },
    created: function () {
      eventHub.$on('download', this.download)
    },
    mounted: function () {
      Object.assign(this.defaultOptions, this.options)

      const vm = this
      const el = $(this.$el)
      let dataSource = {}
      this.proxyData = this.value

      // 넘어온 URL이 있을경우
      if (this.dataUrl !== '') {
        dataSource = this.setDataSource()
        Object.assign(dataSource, this.dataOptions)

        dataSource['schema']['data'] = 'results'
        dataSource['transport'] = {
          read: {
            url: this.dataUrl,
            beforeSend: function (req) {
              // API에 인증이 필요할 경우, request header에 토큰 세팅 세팅.
              if (vm.auth) {
                req.setRequestHeader('Authorization', 'JWT ' + localStorage.getItem('_t'))
              }
            }
          },
          dataType: 'jsonp',
          parameterMap: function (data) {
            let parameters = {
              format: 'json',
              page: data.page,
              pageSize: data.pageSize
            }

            // 전달받은 파라미터가 있을 경우, 기본으로 설정해준다.
            const param = vm.options.parameter
            if (param) {
              for (let i in param) {
                parameters[param[i].name] = param[i].value
              }
            }

            parameters = Object.assign(data, parameters)
            delete parameters['skip']
            delete parameters['take']

            return parameters
          }
        }

        // column 중에 multi 옵션이 있는 경우에는 서버페이징으로 인해 unique URL을 따로 제공해야한다.
        // unique URL을 자동으로 가져올 수 있도록 처리한다.
        var urlOrigin = this.filterUrl !== '' ? this.filterUrl : this.dataUrl.split('?')[0]
        this.defaultOptions['columns'].forEach(function (e, i) {
          if (e.hasOwnProperty('filterable')) {
            if (e.filterable.hasOwnProperty('multi') && e.filterable.multi) {
              const data = {
                format: 'json',
                field: e.field
              }
              if (e.fieldOption) {
                Object.assign(data, e.fieldOption)
              }
              e.filterable['dataSource'] = {
                transport: {
                  read: {
                    url: urlOrigin + 'unique/',
                    data: data,
                    beforeSend: function (req) {
                      // API에 인증이 필요할 경우, request header에 토큰 세팅 세팅.
                      if (vm.auth) {
                        req.setRequestHeader('Authorization', 'JWT ' + localStorage.getItem('_t'))
                      }
                    }
                  }
                }
              }
            }
          }
        })
      } else if (this.proxyData.length > 0) {
        Object.assign(dataSource, {
          data: this.proxyData,
          schema: {
            model: {
              fields: this.fields
            }
          },
          pageSize: this.pageSize
        })
      }

      // 그리드 초기화 옵션 설정
      this.defaultOptions['dataSource'] = dataSource

      if (this.autoFitColumn) {
        this.defaultOptions['dataBound'] = this.setAutoFitColumn
      }

      // 그리드 초기화
      el.kendoGrid(this.defaultOptions)
      this.grid = el.data('kendoGrid')

      // 초기화 이벤트
      this.resizeGrid()
      this.setTouchEvent()
      this.setTooltip()

      window.addEventListener('resize', this.resizeGrid)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeGrid)
      eventHub.$off('download', this.download)
    }
  }
</script>

<style lang="scss">
  .k-grid-default {
    tr:hover {
      background-color: $light-grey;
      border: solid 1px $hzc-gray-02;
    }

    font-size: 14px;
    color: $font-color;
    border-color: $border-color;
    border-radius: 4px;

    .k-grid-header {
      border-color: $border-color;
      &-wrap {
        border-color: $border-color;
        border-radius: 4px 4px 0 0;
      }

      th.k-header {
        background-color: $hzc-white;
        border-width: 0 0 1px 0;
        border-color: $border-color;
        vertical-align: middle;
        text-align: left;
        font-weight: bold;
        font-size: 12px;
        color: $header-color;
        .k-link {
          padding: 0;
          margin: 0;
        }
      }
    }

    .k-grid-content {
      min-height: 320px;
      border: 0;
      white-space: nowrap !important;

      td {
        font-size: 14px;
        color: $font-color;
        border: 0;
      }
    }

    .k-alt, .k-separator, .k-resource.k-alt,
    .k-pivot-layout > tbody > tr:first-child > td:first-child {
      background-color: $hzc-white;
    }

    .k-pager-wrap {
      margin: 0;
      padding: 8px 16px;
      color: $font-color;
      background-color: $hzc-white;
      border-width: 1px 0 0 0;
      border-color: $border-color;
      font-size: 14px;
      text-align: center;

      .k-link:hover {
        background-color: $light-grey;
      }

      .k-pager-refresh {
        background-color: $hzc-white;
        &:hover {
          background-color: $light-grey;
        }
      }

      @media only screen and (max-width: 1024px) {
        .k-pager-numbers {
          top: 10px;
          left: 4.8em;
        }
      }
    }

    .k-state-selected,
    .k-state-focused {
      color: $font-color;
      background-color: $light-grey;
      border: solid 1px $hzc-gray-02;
      box-shadow: none;
    }
  }

  .k-multicheck-wrap {
    .k-item {
      line-height: normal;
    }
    input[type=radio],
    input[type=checkbox] {
      vertical-align: -2px;
      margin-right: 4px;
    }
  }

  .k-action-buttons {
    border-color: $border-color;
    text-align: center;
    bottom: 0;
    margin: 8px -8px 0;
    padding: 2px 8px;
  }

  .k-i-filter:before {
    content: "⌵";
    top: -6px;
    font-size: 12px;
    color: $font-color;
  }
  .k-i-more-vertical:before {
    content: "⌵";
    font-size: 12px;
    color: $font-color;
  }
  .k-grid-norecords-template {
    border: 0;
  }
  .k-button {
    border-radius: 0;
    border-color: $border-color !important;
    box-shadow: none !important;
  }
  .k-primary {
    color: $hzc-white !important;
    border: none !important;
    background-color: $primary-color-v2;
    &:hover {
      background-color: darken($primary-color-v2, 10%);
    }
    &:active {
      background-color: darken($primary-color-v2, 10%) !important;
    }
    &:focus {
      background-color: darken($primary-color-v2, 10%) !important;
    }
  }

  .k-link:link, .k-link:visited, .k-nav-current.k-state-hover .k-link {
    height: 100%;
    border: 0 !important;
    color: $font-color !important;
    cursor: pointer !important;
  }

  .k-grid, .k-scheduler, .k-menu, .k-editor {
    border-radius: 4px;
  }

  .k-grid-norecords {
    height: 98%;
  }

  /* 그리드 th, td 사이즈 */
  .k-grid-lg {
    .k-grid-header {
      height: 48px;
      th.k-header {
        height: 48px;
        padding: 0 16px;
      }
    }
    .k-grid-content {
      td {
        height: 48px;
        padding: 0 16px;
      }
    }
  }

  .k-grid-md {
    .k-grid-header {
      th.k-header {
        padding: 6px 8px;
      }
    }
    .k-grid-content {
      td {
        height: 32px;
        padding: 0 8px;
      }
    }
  }

  .k-grid-xs {
    .k-grid-header {
      height: 24px;
      th.k-header {
        height: 24px;
        padding: 0 16px;
      }
    }
    .k-grid-content {
      td {
        height: 24px;
        padding: 0 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ../common/components/KendoGrid.vue